import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    wrapper: {
        overflow: 'hidden',
        maxHeight: 0,
        transition: `max-height 0.4s`,
    },
}));
